module.exports = __webpack_public_path__ + "img/email.5ee9378b.svg";